import {Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {observer} from "mobx-react";
import * as React from "react";
import PermissionCheckbox from "./PermissionCheckbox";

function PermissionMatrixGroup({permissionGroup, form, fieldName, matchesPermissionSearch}) {
    const rowMatchesPermissionSearch = (row) => row.permissions.some(permission => matchesPermissionSearch(permission))

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell/>
                    {permissionGroup.columnNames.map(columnName => (
                        <TableCell key={columnName} align="center">{columnName}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {permissionGroup.rows.map(row => (
                    <TableRow key={row.name} sx={{opacity: rowMatchesPermissionSearch(row) ? 1 : 0.3}}>
                        <TableCell>{row.name}</TableCell>
                        {row.permissions.map(permission => (
                            <TableCell key={permission} align="center">
                                <PermissionCheckbox permission={permission} form={form} fieldName={fieldName}/>
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )
}

export default observer(PermissionMatrixGroup);
